import { Result } from "@/main/models/common/resultResponse";
import { RateGridRequest, RateSaveRequest, DeleteRateRequest } from "@/main/models/request/rateRequest";
import { RateRegistrationDataResponse, RateResponse } from "@/main/models/response/rateResponse";
import { AxiosResponse } from "axios";

export abstract class IRateApi {
	abstract searchGrid(request: RateGridRequest): Promise<AxiosResponse<Result<RateResponse[]>>>;
	abstract save(request: RateSaveRequest): Promise<AxiosResponse<Result<RateResponse>>>;
	abstract deleteRate(request: DeleteRateRequest): Promise<AxiosResponse<Result<any>>>;
	abstract getRateRegistrationData(guidRate: string): Promise<AxiosResponse<Result<RateRegistrationDataResponse>>>;
}
